import { render, staticRenderFns } from "./projectRatio.vue?vue&type=template&id=037b3b98&"
import script from "./projectRatio.vue?vue&type=script&lang=js&"
export * from "./projectRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports